export default {
  path: "downloader",
  component: () => import("./pages/youtube.thumbnail.downloader._.vue"),
  children: [
    {
      name: "youtube.thumbnail.downloader.index",
      path: "",
      component: () => import("./pages/youtube.thumbnail.downloader.index.vue")
    },
    {
      name: "youtube.thumbnail.downloader.show",
      path: ":id",
      component: () => import("./pages/youtube.thumbnail.downloader.show.vue")
    }
  ]
};
